import { Dropdown } from "primereact/dropdown";
import React from "react";

interface DataTableActionTemplateProps {
  openDeleteDialog?: () => void;
  openEditDialog?: () => void;
  openDetails?: () => void;
  openAddContentGroup?: () => void;
  openMetadataDialog?: () => void;
  openPostersDialog?: () => void;
  openAddToContent?: () => void;
  openLicenseOfContentDialog?: () => void;
  openPlayDialog?: () => void;
}

const DataTableActionTemplate: React.FC<DataTableActionTemplateProps> = ({
  openDeleteDialog,
  openEditDialog,
  openDetails,
  openAddContentGroup,
  openMetadataDialog,
  openPostersDialog,
  openAddToContent,
  openLicenseOfContentDialog,
  openPlayDialog,
}) => {
  const actions = [
    ...(openEditDialog ? [{ label: 'Edit', icon: 'pi pi-pencil', command: openEditDialog }] : []),
    ...(openDetails ? [{ label: 'Details', icon: 'pi pi-user', command: openDetails }] : []),
    ...(openAddToContent ? [{ label: 'Search', icon: 'pi pi-search', command: openAddToContent }] : []),
    ...(openMetadataDialog ? [{ label: 'Metadata', icon: 'pi pi-info-circle', command: openMetadataDialog }] : []),
    ...(openPostersDialog ? [{ label: 'Posters', icon: 'pi pi-images', command: openPostersDialog }] : []),
    ...(openAddContentGroup ? [{ label: 'Add to Group', icon: 'pi pi-arrows-h', command: openAddContentGroup }] : []),
    ...(openLicenseOfContentDialog ? [{ label: 'License', icon: 'pi pi-tablet', command: openLicenseOfContentDialog }] : []),
    // ...(openDeleteDialog ? [{ label: 'Delete', icon: 'pi pi-trash', command: openDeleteDialog }] : []),
    ...(openPlayDialog ? [{ label: 'Play', icon: 'pi pi-play', command: openPlayDialog }] : [])
  ];

  return (
    <Dropdown
      value={null}
      options={actions}
      onChange={(e) => e.value?.command()}
      optionLabel="label"
      placeholder="Actions"
      className="p-button-outlined"
      style={{ minWidth: '120px' }}
    />
  );
};

export default DataTableActionTemplate;
